import { render } from "./PaymentMethodsPills.vue?vue&type=template&id=4807cdd3"
import script from "./PaymentMethodsPills.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentMethodsPills.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/PaymentMethodsPills.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4807cdd3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4807cdd3', __exports__)) {
    api.reload('4807cdd3', __exports__)
  }
  
  module.hot.accept("./PaymentMethodsPills.vue?vue&type=template&id=4807cdd3", () => {
    api.rerender('4807cdd3', render)
  })

}


export default __exports__